module.exports = __webpack_public_path__ + "static/media/NUS_Biathlon_Logo_No_Year.a960d95d.png";